import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/pro-regular-svg-icons';
import { TextField } from '@mui/material';
import { Accordion } from '@design-system/components/accordion/Accordion';
import { AccordionHeader } from '../components/AccordionHeader';
import { sectionConfigs } from '../components/sectionConfigs';

type SignInEmailSectionProps = {
  signInEmail: string;
};

export const SignInEmailSection = ({
  signInEmail,
}: SignInEmailSectionProps) => {
  const config = sectionConfigs.signInEmail;

  return (
    <Accordion
      defaultOpen={true}
      renderHeader={() => (
        <AccordionHeader
          icon={<FontAwesomeIcon icon={faEnvelope} />}
          iconBg={config.iconBg}
          iconColor={config.iconColor}
          title={config.title}
          description={config.description}
        />
      )}
    >
      <div className="w-full">
        <span className="p-1 leading-5 text-sm font-medium">Email *</span>
        <TextField className="w-full" value={signInEmail} disabled />
      </div>
    </Accordion>
  );
};
